
import ResponsiveTable from '../../../components/ResponsiveTable';
import { hideLoading, showLoading } from '../../../loading';
import request from '../../../request';
import swal from 'sweetalert';
import { Link } from 'react-router';
import PillLabel from '../../../components/PillLabel';
import { IconButton } from '@mui/material';
import { Visibility as ViewIcon, LocationOn as MapIcon } from '@mui/icons-material';
import { INSTALLATION_STATUS } from '../../../../../shared/constants';
import StyledLink from '../../../components/StyledLink';
import links from '../../../links';
import NavigationStateSaver from '../../../components/NavigationStateSaver';
import { getAgentFullName } from '../../../../../shared/utils';


export default class List extends NavigationStateSaver {

   state = {
      installations: null,
      page: 0,
      rowsPerPage: 10,
      total: 0,
      filters: {
         status: undefined,
         from: undefined,
         to: undefined,
      },
   }

   fetchInstallations = async () => {
      
      try {

         showLoading();

         const { page, rowsPerPage } = this.state;

         const params = {
            page: page + 1,
            limit: rowsPerPage,
         }

         const { status, from, to } = this.state.filters;
         if (status) params.status = status;
         if (from) params.from = from;
         if (to) params.to = to;

         const res = await request.get('/api/general/installations', { params });
         const { installations, total } = res.data;

         this.setState({ installations, total });

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.installations)
         await this.fetchInstallations();
   }

   render() {
      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'product',
                  caption: 'Product',
                  render: product => product ? product.name : '–',
               },
               {
                  field: 'customer',
                  caption: 'Customer',
                  render: customer => customer ? <StyledLink to={links.customer(customer._id)}>
                     {customer.is_company ? customer.name : `${customer.name} ${customer.surname}`}
                  </StyledLink> : '–',
               },
               {
                  field: 'agent',
                  caption: 'Agent',
                  render: agent => {
                     if (!agent) return '–';
                     return <StyledLink to={links.agent(agent._id)}>
                        {getAgentFullName(agent)}
                     </StyledLink>;
                  }
               },
               {
                  field: 'loan',
                  caption: 'Loan',
                  render: loan => {
                     if (!loan)
                        return '–';
                     return <StyledLink to={links.loan(loan._id)}>
                        {loan.loan_no}
                     </StyledLink>;
                  },
               },
               {
                  field: 'location',
                  caption: 'Location',
                  render: location => {
                     if (!location)
                        return '–';
                     return <IconButton>
                        <a href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.long}`} target='_blank' rel='noreferrer'>
                           <MapIcon />
                        </a>
                     </IconButton>;
                  },
               },
               {
                  field: 'status',
                  caption: 'Status',
                  render: status => {
                     return <PillLabel>{status.toUpperCase()}</PillLabel>;
                  },
               },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, row) => {
                     return <Link to={links.installation(row._id)}>
                        <IconButton>
                           <ViewIcon />
                        </IconButton>
                     </Link>;
                  },
               }
            ]}
            rows={this.state.installations}
            fullHeight
            onRefresh={this.fetchInstallations}
            pagination={{
               page: this.state.page,
               rowsPerPage: this.state.rowsPerPage,
               count: this.state.total,
               onPageChange: (_, page) => this.setState({ page }, this.fetchInstallations),
               onRowsPerPageChange: e => this.setState({ rowsPerPage: e.target.value, page: 0 }, this.fetchInstallations),
               labelRowsPerPage: 'Installations per page',
            }}
            filters={{
               onChange: filters => this.setState({ filters, page: 0 }, this.fetchInstallations),
               filters: [
                  {
                     field: 'status',
                     label: 'Status',
                     type: 'select',
                     options: Object
                        .values(INSTALLATION_STATUS)
                        .map(status => ({ value: status, label: status.toUpperCase() })),
                     value: this.state.filters.status,
                  },
                  {
                     field: 'from',
                     label: 'From',
                     type: 'date',
                     value: this.state.filters.from,
                  },
                  {
                     field: 'to',
                     label: 'To',
                     type: 'date',
                     value: this.state.filters.to,
                  },
               ],
            }}
         />
      </>
   }
}